export class UserResponseModel {
  Id: number;
  UserName: string;
  Name: string;
  LastName: string;
  apiKey: string;
  Email: string;
  EmailConfirmed: boolean;
  FirmId: number;
  dealerCode: string;
  channelCode: string;
  Logo: string;
  IsActive: boolean;
  IsVbtAdmin: boolean;
  PasswordHash: string;
  PhoneNumber: string;
  PhoneNumberConfirmed: boolean;
  SecurityStamp: string;
  SessionKey: string;
}
